var _g, _path, _path2, _rect, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotAllowed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 798.922,
    height: 774.848,
    viewBox: "0 0 798.922 774.848",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-720.266 -215.996)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(880.894 416.032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.2,84.913s10.938-21.875,8.756-41.554l36.4,18.863L377.95,98.032,334.2,84.913Z",
    transform: "translate(-264.493 7.679)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.841,
    cy: 32.841,
    rx: 32.841,
    ry: 32.841,
    transform: "translate(61.143 12.693)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.05,429.314H373.1l9.53-77.294H353.05Z",
    transform: "translate(-294.294 133.506)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.891,413.146h0c.619,1.056.957,4.448.957,5.659h0a6.8,6.8,0,0,1-6.8,6.8H330a4.65,4.65,0,0,1-4.645-4.645v-2.59s-3.069-7.77,3.252-17.328c0,0,7.855,7.489,19.595-4.237l3.463-6.264,25.056,18.328,13.894,1.7c3.041.38,5.729-.056,7.292,2.576h-.014Z",
    transform: "translate(-270.484 149.209)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.237,74.779l-48.128-6.56-37.19,17.5L313.737,221.33s91.47,10.937,105.884-3.28S423.1,90.094,423.1,90.094L401.223,74.779h.014Z",
    transform: "translate(-283.402 17.813)",
    fill: "#044d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.531,45.174c1.028,5.743-3.1,11.923-3.1,11.923l-1.552-.64S-13.1,3.057,23.987.2s45.341,26,45.341,26,1.175,13.644-2.95,9.519-30.018-5.395-30.018-5.395l-18.93-3.055S7.5,39.43,8.531,45.174Z",
    transform: "translate(54.751 7.263) rotate(-6)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.67,416.13l19.271,5.434,30.18-71.776-28.463-8.038Z",
    transform: "translate(-168.796 129.32)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.823,417.468h0c.31,1.182-.3,4.533-.619,5.715h0a6.8,6.8,0,0,1-8.39,4.7L284.1,411.021a4.652,4.652,0,0,1-3.209-5.729l.7-2.492s-.845-8.305,7.841-15.794c0,0,5.518,9.347,20,1.239l5.039-5.1,19.13,24.437,12.894,5.419c2.815,1.182,5.532,1.506,6.32,4.462Z",
    transform: "translate(-162.761 146.197)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.785,167.669l-6.56,19.848v68.2l25.266,228.17,30.993-3.218,6.227-166.041L324.29,242.05l73.353,110.98L360.727,467.145H391.42s62.543-132.12,54.6-143.845S366.97,173.257,366.97,173.257s-95.158-3.392-95.158-5.574h0Z",
    transform: "translate(-234.876 58.355)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.236,111.729l-10.571,17.314s-14.949,58.756,0,58.995S430.794,158.1,430.794,158.1l-3.941-15.752-10.937,4.378,2.182-34.994H396.236Z",
    transform: "translate(-379.02 35.55)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.644,80.678S388.65,74.512,385.37,97.415s-5.11,44.609-5.11,44.609l37.922,3.139,5.462-64.485Z",
    transform: "translate(-373.616 22.584)",
    fill: "#044d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.084,229.193l49.382-42.081a2.884,2.884,0,0,0,.207-4.066L343.7,89.193a2.884,2.884,0,0,0-4.047-.441l-49.382,42.081a2.884,2.884,0,0,0-.207,4.066l79.978,93.854A2.884,2.884,0,0,0,374.084,229.193Z",
    transform: "translate(-246.373 25.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.084,229.193l49.382-42.081a2.884,2.884,0,0,0,.207-4.066L343.7,89.193a2.884,2.884,0,0,0-4.047-.441l-49.382,42.081a2.884,2.884,0,0,0-.207,4.066l79.978,93.854A2.884,2.884,0,0,0,374.084,229.193Z",
    transform: "translate(-246.373 25.924)",
    fill: "none",
    stroke: "#2f2e41",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.5,92.419l19.876,4.11s53.125,29.237,43.074,40.315-52.7,12.5-52.7,12.5l-8.812-13.64,10.67-5L262.551,108.4,277.5,92.419Z",
    transform: "translate(-125.994 27.679)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.074,93.836s19.412-29.772,38.373-16.512S368.5,104.07,368.5,104.07L344.876,133.9,294.06,93.836h.014Z",
    transform: "translate(-197.129 20.138)",
    fill: "#044d6e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.882,
    cy: 19.749,
    rx: 9.882,
    ry: 19.749,
    transform: "translate(129.995 186.4) rotate(-101.44)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.882,
    cy: 19.749,
    rx: 9.882,
    ry: 19.749,
    transform: "translate(48.162 199.779) rotate(-125.46)",
    fill: "#9f616a"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M816.547,70V653.653c-.465.1-.929.183-1.408.253q-10.705,1.942-21.692,3.744-13.049,2.154-26.464,4.167-11.149,1.647-22.523,3.2-33.129,4.54-68.046,8.052-11.17,1.14-22.523,2.154c-66.089,5.94-136.332,9.15-209.164,9.15q-15.477,0-30.771-.2c-.479,0-.943,0-1.408-.014V70Z",
    transform: "translate(701.233 147.408)",
    fill: "#f2f2f2",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M815.547,262.957v1.731l.183-.366A7.744,7.744,0,0,0,815.547,262.957Zm-402.59,183.9-1.408-1.14v126.52h1.408V684.565c.464.014.929.014,1.408.014V361.521c-.465.253-.929.493-1.408.732ZM411.55,69v615.54c.464.014.929.028,1.408.028s.929.014,1.408.014V71.812H815.547v582.5c.479-.07.943-.155,1.408-.253.464-.07.943-.155,1.408-.253V69H411.55Z",
    transform: "translate(700.825 147)",
    fill: "#d6d6e3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M606.523,392.5V541.6q-11.17,1.14-22.523,2.154V392.5Z",
    transform: "translate(771.126 278.877)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 648.93,
    height: 26.745,
    transform: "translate(720.266 692.49)",
    fill: "#044d6e"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.07, 0.998, -0.998, -0.07, 1022.411, 580.41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.72,31.441a15.72,15.72,0,1,1,15.72-15.72A15.738,15.738,0,0,1,15.72,31.441Zm0-20.96a5.24,5.24,0,1,0,5.24,5.24A5.246,5.246,0,0,0,15.72,10.48Z",
    transform: "translate(18.341 0)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1,39.3A5.224,5.224,0,0,1,9.4,37.766l-7.86-7.86a5.24,5.24,0,0,1,0-7.411L22.5,1.535a5.24,5.24,0,0,1,7.411,7.411L12.651,26.2l4.155,4.155A5.24,5.24,0,0,1,13.1,39.3Z",
    transform: "translate(0 18.341)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1,18.34A5.224,5.224,0,0,1,9.4,16.806l-7.86-7.86A5.24,5.24,0,0,1,8.946,1.535l7.86,7.86A5.24,5.24,0,0,1,13.1,18.34Z",
    transform: "translate(10.48 28.821)",
    fill: "#090814"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1255.578 340.147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M553.466,494.094c-21.04,0-38.174-18.191-38.174-40.55s17.124-40.55,38.174-40.55,38.174,18.191,38.174,40.55S574.515,494.094,553.466,494.094Zm0-70.857c-15.4,0-27.926,13.594-27.926,30.3s12.528,30.3,27.926,30.3,27.927-13.6,27.927-30.3-12.528-30.3-27.927-30.3Z",
    transform: "translate(-493.261 -412.993)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.851,558.846H520.543A24.071,24.071,0,0,1,496.5,534.8V463.883a16.484,16.484,0,0,1,16.47-16.47h87.468a16.481,16.481,0,0,1,16.47,16.47V534.8a24.071,24.071,0,0,1-24.055,24.047Z",
    transform: "translate(-496.5 -407.077)",
    fill: "#044d6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.021,483.91a14.089,14.089,0,1,0-20.493,12.539v22.044h12.817V496.449a14.077,14.077,0,0,0,7.676-12.539Z",
    transform: "translate(-489.731 -403.226)",
    fill: "#f2f2f2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAllowed);
export default __webpack_public_path__ + "static/media/not-allowed.10e5f252e6942f8fec2a11b22f4632a0.svg";
export { ForwardRef as ReactComponent };